import React from "react";
import "../Styles/AddFamilyModal.css";

const AddFamilyModal = ({
  visible,
  onClose,
  onAdd,
  familyMemberName,
  setFamilyMemberName,
  roleDesc,
  setRoleDesc,
  Occupation,
  setOccupation,
  selectedRelationShip,
  setSelectedRelationShip,
  relationshipOptions
}) => {
  if (!visible) return null;

  const handleAdd = () => {
    if (!selectedRelationShip?.RelationshipName) {
      alert("Please select a relationship.");
    } else if (!familyMemberName.trim()) {
      alert("Please enter the family member's name.");
    } else if (!roleDesc.trim()) {
      alert("Please enter a role description.");
    } else {
      onAdd();
    }
  };

  return (
    <div className="add-family-modal__overlay">
      <div className="add-family-modal__content">
        
        <label className="add-family-modal__label">Select Relationship:</label>
        <select
          className="add-family-modal__select scrollable-select"
          value={selectedRelationShip?.RelationshipId || ""}
          onChange={(e) => {
            const selected = relationshipOptions.find(
              (opt) => opt.RelationshipId === Number(e.target.value)
            );
            if (selected) {
              setSelectedRelationShip(selected);
            }
          }}
        >
          <option value="">Select Relationship</option>
          {relationshipOptions.map((relation) => (
            <option
              key={relation.RelationshipId}
              value={relation.RelationshipId}
            >
              {relation.RelationshipName}
            </option>
          ))}
        </select>

        <label className="add-family-modal__label">Family Member Name:</label>
        <input
          className="add-family-modal__input"
          value={familyMemberName}
          onChange={(e) => setFamilyMemberName(e.target.value)}
          placeholder="Enter name"
        />

        <label className="add-family-modal__label">Occupation:</label>
        <input
          className="add-family-modal__input"
          value={Occupation}
          onChange={(e) => setOccupation(e.target.value)}
          placeholder="Enter Occupation"
        />

        <label className="add-family-modal__label">Role Description:</label>
        <input
          className="add-family-modal__input"
          value={roleDesc}
          onChange={(e) => setRoleDesc(e.target.value)}
          placeholder="Enter role"
        />

        <div className="add-family-modal__button-row">
          <button
            className="add-family-modal__button"
            onClick={handleAdd}
          >
            Add
          </button>
          <button
            className="add-family-modal__button add-family-modal__button--cancel"
            onClick={onClose}
          >
            Cancel
          </button>
        </div>

      </div>
    </div>
  );
};

export default AddFamilyModal;
